import { render, staticRenderFns } from "./SchoolModal.vue?vue&type=template&id=181b10e8&"
import script from "./SchoolModal.vue?vue&type=script&lang=js&"
export * from "./SchoolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports